import React from "react";
import { Modal, Button, Checkbox, Row, Col, Image } from "antd";

const formatDate = (dateString) => {
    const date = new Date(dateString);
    const dayOfWeek = date.toLocaleString('default', { weekday: 'long' });
    const monthName = date.toLocaleString('default', { month: 'long' });
    const day = date.getDate();
    const year = date.getFullYear();
    const getDaySuffix = (day) => {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };
    return `${dayOfWeek}, ${monthName} ${day}${getDaySuffix(day)}, ${year}`;
};

const groupImagesByDate = (images) => {
    const grouped = {};
    images.forEach(img => {
        const dateKey = img.created_at ? formatDate(img.created_at) : 'No Date';
        if (!grouped[dateKey]) {
            grouped[dateKey] = [];
        }
        grouped[dateKey].push(img);
    });
    return grouped;
};

const AddPhotoModal = ({
    visible,
    onCancel,
    onAdd,
    adding,
    projectImages,
    selectedImages,
    setSelectedImages
}) => {
    const handleSelectAll = (checked) => {
        if (checked) {
            const allImageIds = projectImages.map(img => img.id);
            setSelectedImages(allImageIds);
        } else {
            setSelectedImages([]);
        }
    };

    const handleDateSelect = (date, images, checked) => {
        const dateImageIds = images.map(img => img.id);
        if (checked) {
            setSelectedImages([...new Set([...selectedImages, ...dateImageIds])]);
        } else {
            setSelectedImages(selectedImages.filter(id => !dateImageIds.includes(id)));
        }
    };

    const isDateSelected = (images) => {
        const dateImageIds = images.map(img => img.id);
        return dateImageIds.every(id => selectedImages.includes(id));
    };

    const isDateIndeterminate = (images) => {
        const dateImageIds = images.map(img => img.id);
        const selectedCount = dateImageIds.filter(id => selectedImages.includes(id)).length;
        return selectedCount > 0 && selectedCount < dateImageIds.length;
    };

    return (
        <Modal
            className="add-Photo-to-Report-model"
            title="Add Photos to Report"
            open={visible}
            onCancel={onCancel}
            footer={[
                <Button key="clear" onClick={() => setSelectedImages([])}>
                    Clear Selection
                </Button>,
                <Button className="submitBtn" key="add" type="primary" onClick={onAdd} loading={adding}>
                    Add Photo to the Report ({selectedImages.length})
                </Button>
            ]}
        >
            <div style={{ marginBottom: '16px', padding: '12px', background: '#f5f5f5', borderRadius: '4px' }}>
                <Checkbox
                    checked={selectedImages.length === projectImages.length && projectImages.length > 0}
                    indeterminate={selectedImages.length > 0 && selectedImages.length < projectImages.length}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                >
                    <strong>Select All ({projectImages.length} photos)</strong>
                </Checkbox>
            </div>
            <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
                {Object.entries(groupImagesByDate(projectImages)).map(([date, images]) => (
                    <div key={date} style={{ marginBottom: '24px' }}>
                        <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '12px', color: '#333', display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <Checkbox
                                checked={isDateSelected(images)}
                                indeterminate={isDateIndeterminate(images)}
                                onChange={(e) => handleDateSelect(date, images, e.target.checked)}
                            />
                            {date} ({images.length} photos)
                        </div>
                        <Row gutter={[12, 12]}>
                            {images.map((img) => (
                                <Col className="projectImages-col" xs={12} sm={8} md={6} lg={4} key={img.id}>
                                    <div
                                        onClick={() => {
                                            if (selectedImages.includes(img.id)) {
                                                setSelectedImages(selectedImages.filter(id => id !== img.id));
                                            } else {
                                                setSelectedImages([...selectedImages, img.id]);
                                            }
                                        }}
                                        style={{
                                            border: selectedImages.includes(img.id) ? '3px solid #1890ff' : '1px solid #e0e0e0',
                                            borderRadius: '8px',
                                            padding: '8px',
                                            cursor: 'pointer',
                                            position: 'relative'
                                        }}
                                    >
                                        {selectedImages.includes(img.id) && (
                                            <div style={{ position: 'absolute', top: '4px', right: '4px', background: '#1890ff', color: 'white', borderRadius: '50%', width: '20px', height: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: '9', fontSize: '12px' }}>✓</div>
                                        )}
                                        <Image src={img.image_url} preview={false} style={{ width: '100%', height: '180px', objectFit: 'cover', borderRadius: '4px' }} />
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </div>
                ))}
            </div>
        </Modal>
    );
};

export default AddPhotoModal;


